/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-return-assign */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-nested-ternary */
// eslint-disable-next-line no-unused-expressions

import React, { useRef, useState, useEffect, useCallback } from 'react';
import {
  AppShell,
  Navbar,
  Tabs,
  Paper,
  Group,
  Title,
  Aside,
  Image,
  Modal,
  Divider,
  Space,
  ActionIcon,
  Text,
  Stack,
  Input,
  Box,
  Center,
  MediaQuery,
  useMantineTheme,
  Button,
  NumberInput,
} from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { useFocusTrap } from '@mantine/hooks';
import Keyboard from 'react-simple-keyboard';
import { w3cwebsocket as W3CWebSocket } from 'websocket';
import dayjs from 'dayjs';
import { CircleX, Edit, EditOff } from 'tabler-icons-react';
import 'react-simple-keyboard/build/css/index.css';
import LandingLayout from '../../components/LandingLayout';
import OTPInput from '../../components/OTPInput/OTPInput';
import { sendRequest } from '../../services/services';
import { applyKeyboardButton, syncKeyboardValue } from '../../utils/keyboard';
import PaymentStatus from '../PaymentStatus/PaymentStatus';
import CashierAmount from '../PaymentStatus/CashierPrint';
import PrintInvoice from '../PaymentStatus/invoice';
import Profile from '../Profile/profile';
import cashIcon from '../../image/cash.png';
import cardIcon from '../../image/card.png';

const Home = () => {
  const focusTrapRef = useFocusTrap();
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const [cardPay, setCardPay] = useState(false);
  const [payOpen, setPayOpen] = useState(false);
  const [cashOpened, setCashOpened] = useState(false);
  const [openInvoice, setOpenInvoice] = useState(false);
  const [, setInput] = useState('');
  const [layout, setLayout] = useState('default');
  const keyboard = useRef();
  const plateCharKeyboardRef = useRef();
  const plateNumKeyboardRef = useRef();
  const ticketKeyboardRef = useRef();
  const mobileKeyboardRef = useRef();
  const [ticketNumber, setTicketNumber] = useState('');
  const [dummyInput, setDummyInput] = useState('');
  const [dummycharInput, setDummyCharInput] = useState('');
  const dummyInputRef = useRef('');
  const dummyCharInputRef = useRef('');
  dummyInputRef.current = dummyInput;
  dummyCharInputRef.current = dummycharInput;
  const [shiftButtonText, setShiftButtonText] = useState('Arabic');
  const [ticketData, setTicketData] = useState();
  const [vehicleData, setVehicleData] = useState();
  const [, setCashData] = useState();
  const [response, setResponse] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');
  const [profileData, setProfileData] = useState('');
  const [totalAmountData] = useState();
  const [inputData, setInputData] = useState('');
  const [ticketIdData, setTicketIdData] = useState();
  const [mobileData, setMobileData] = useState('');
  const [isMobileEdit, setIsMobileEdit] = useState(false);
  const [touched, setTouched] = useState(false);
  const [activeTab, setActiveTab] = useState('first');

  // const valet = ticketData?.result?.invoices?.payable_amount + 100 + 15;

  useEffect(() => {
    sendRequest(`cashier/profile`, 'get').then((res) => {
      setProfileData(res?.data || []);
    });
  }, []);
  // console.log('sada', valet);
  const cardPayment = () => {
    const wsurl = `ws://localhost:5000/messages`;

    // Init Websocket Client
    const client = new W3CWebSocket(wsurl);
    client.onerror = () => {
      console.log('Connection Error');
    };

    client.onopen = () => {
      console.log('WebSocket Client Connected');

      function connectPort() {
        if (client.readyState === client.OPEN) {
          const comName = 'COM3';
          const sendData = JSON.stringify({
            // Event: "CONNECTION",
            // Operation: "CONNECT",
            // IpAddress: "192.168.8.104",
            // ConnectionMode: "TCP",
            // Port: 6100
            Event: 'CONNECTION',
            Operation: 'CONNECT',
            connectionMode: 'COM',
            comName,
            braudRate: '38400',
            dataBits: '8',
            parity: 'none',
          });

          client.send(sendData);
        }
      }

      connectPort();

      function sendAmount() {
        if (client.readyState === client.OPEN) {
          // const amount = ticketData?.result?.invoices?.payable_amount;
          const amount = Math.round(ticketData?.result?.invoices?.payable_amount);
          // const amount = valet;
          const sendAmountData = JSON.stringify({
            Event: 'TRANSACTION',
            Operation: 'PURCHASE',
            Amount: amount,
            PrintSettings: '1',
            AppId: '11',
            ECRNumber: '1234567890123456',
          });
          client.send(sendAmountData);
        }
      }
      sendAmount();
    };

    client.onclose = () => {
      function closePort() {
        if (
          paymentStatus?.TransactionResponseEnglish ||
          paymentStatus?.TransactionResultReasonEnglish === 'APPROVED'
        ) {
          const sendData = JSON.stringify({
            Event: 'CONNECTION',
            Operation: 'DISCONNECT',
          });
          client.send(sendData);
        }
      }
      closePort();
      console.log('echo-protocol Client Closed');
    };

    client.onmessage = (message) => {
      if (typeof message.data === 'string') {
        // console.log('Received', message.data);
        setResponse(JSON.parse(message?.data));
      }
    };
    if (ticketData?.result?.invoices?.invoice_status?.name === 'paid') {
      setCardPay(true);
    }
  };

  useEffect(() => {
    if (response?.TerminalAction === 'SWIPE_OR_INSERT') {
      setCardPay(true);
    } else if (response?.TerminalAction === 'IDLE_SCREEN') {
      setCardPay(false);
    } else if (response?.EventName === 'TERMINAL_RESPONSE') {
      setPaymentStatus(JSON.parse(response?.JsonResult));
    } else if (
      paymentStatus?.TransactionResponseEnglish ||
      paymentStatus?.TransactionResultReasonEnglish === 'Decline'
    ) {
      setPaymentStatus();
    }
  }, [
    paymentStatus?.TransactionResponseEnglish,
    paymentStatus?.TransactionResultReasonEnglish,
    response?.EventName,
    response?.JsonResult,
    response?.TerminalAction,
  ]);

  const searchTicketNumberPlate = () => {
    sendRequest(`tickets/${dummyInput + dummycharInput}`, 'get')
      .then((res) => {
        if (res?.code === 21) {
          setVehicleData(res?.data || []);
          setTicketIdData(vehicleData?.pass_id);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      });
  };

  const searchTicket = useCallback(() => {
    if (inputData || vehicleData?.pass_id) {
      sendRequest(`cashier/reservations-by-pass-id/${inputData || vehicleData?.pass_id}`, 'get')
        .then((res) => {
          if (res?.code === 20) {
            setTicketData(res?.data || []);
            setTicketIdData(inputData);
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            showNotification({
              title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        });
    }
  });

  useEffect(() => {
    if (vehicleData?.pass_id) {
      sendRequest(`cashier/reservations-by-pass-id/${vehicleData?.pass_id}`, 'get')
        .then((res) => {
          if (res?.code === 20) {
            setTicketData(res?.data || []);
            setTicketIdData(vehicleData?.pass_id);
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            showNotification({
              title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        });
    }
  }, [vehicleData, vehicleData?.pass_id]);

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default';
    setLayout(newLayoutName);
    if (shiftButtonText === 'Arabic') {
      setShiftButtonText('English');
    } else if (shiftButtonText === 'English') {
      setShiftButtonText('Arabic');
    }
  };

  const onKeyPress = (button) => {
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === '{shift}' || button === '{lock}') handleShift();
    if (button === '{enter}' && inputData !== '') {
      searchTicket();
    } else if (button === '{enter}' && dummyInput !== '') {
      searchTicketNumberPlate();
    }
  };

  useEffect((button) => {
    if (button === '{enter}') {
      searchTicket() || searchTicketNumberPlate();
    }
  });

  const onChangeNumber = (inputValue) => {
    const sanitized = String(inputValue).replace(/\D/g, '').slice(0, 20);
    setInputData(sanitized);
    if (ticketKeyboardRef.current && ticketKeyboardRef.current.getInput() !== sanitized) {
      ticketKeyboardRef.current.setInput(sanitized);
    }
  };

  const onChangeMobileNumber = (inputValue) => {
    const sanitized = String(inputValue).replace(/\D/g, '').slice(0, 12);
    setMobileData(sanitized);
    setTouched(true);
    if (mobileKeyboardRef.current && mobileKeyboardRef.current.getInput() !== sanitized) {
      mobileKeyboardRef.current.setInput(sanitized);
    }
  };

  const onChangeInputNumber = (event) => {
    const data = event.target.value;
    const sanitized = String(data).replace(/\D/g, '').slice(0, 20);
    setInputData(sanitized);
    if (ticketKeyboardRef.current && ticketKeyboardRef.current.getInput() !== sanitized) {
      ticketKeyboardRef.current.setInput(sanitized);
    }
  };

  const onChangeInputMobileNumber = (event) => {
    const data = event.target.value;
    const sanitized = String(data).replace(/\D/g, '').slice(0, 12);
    setMobileData(sanitized);
    setTouched(true);
    if (mobileKeyboardRef.current && mobileKeyboardRef.current.getInput() !== sanitized) {
      mobileKeyboardRef.current.setInput(sanitized);
    }
  };

  const onInputChange = (e) => {
    setDummyInput(e);
  };

  const onChangePlateChars = (value) => {
    const sanitized = String(value)
      .replace(/[^A-Za-z\u0600-\u06FF]/g, '')
      .slice(0, 3)
      .toUpperCase();
    dummyCharInputRef.current = sanitized;
    setDummyCharInput(sanitized);
    syncKeyboardValue(plateCharKeyboardRef, sanitized);
  };
  const onCharChange = (e) => {
    // Keep compatibility if any other place calls this
    onChangePlateChars(e);
  };
  const InputData = dummyInput + dummycharInput;

  const onChange = () => {
    setInput(InputData);
  };

  const onChangePlateDigits = (value) => {
    const sanitized = String(value)
      .replace(/[^0-9]/g, '')
      .slice(0, 4);
    dummyInputRef.current = sanitized;
    setDummyInput(sanitized);
    syncKeyboardValue(plateNumKeyboardRef, sanitized);
  };

  const onPlateCharKeyPress = (button) => {
    if (button === '{shift}' || button === '{lock}') {
      handleShift();
      return;
    }
    const next = applyKeyboardButton(button, dummyCharInputRef.current, {
      maxLength: 3,
      sanitize: (value) => value.replace(/[^A-Za-z\u0600-\u06FF]/g, '').toUpperCase(),
    });
    dummyCharInputRef.current = next;
    setDummyCharInput(next);
    syncKeyboardValue(plateCharKeyboardRef, next);
  };

  const onPlateDigitKeyPress = (button) => {
    if (button === '{enter}') {
      searchTicketNumberPlate();
      return;
    }
    const next = applyKeyboardButton(button, dummyInputRef.current, {
      maxLength: 4,
      sanitize: (value) => value.replace(/[^0-9]/g, ''),
    });
    dummyInputRef.current = next;
    setDummyInput(next);
    syncKeyboardValue(plateNumKeyboardRef, next);
  };

  const handlePlateDigitKeyDown = (e) => {
    const allowedControlKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Home',
      'End',
    ];
    const isControlCombo = e.ctrlKey || e.metaKey || allowedControlKeys.includes(e.key);
    const isDigit = /^[0-9]$/.test(e.key);
    if (!isControlCombo && !isDigit) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const handlePlateCharKeyDown = (e) => {
    const allowedControlKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Home',
      'End',
    ];
    const isControlCombo = e.ctrlKey || e.metaKey || allowedControlKeys.includes(e.key);
    const isEnglishLetter = /^[A-Za-z]$/.test(e.key);
    const isArabicLetter = /[\u0600-\u06FF]/.test(e.key);
    if (!isControlCombo && !(isEnglishLetter || isArabicLetter)) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const clearPlateInputs = () => {
    dummyInputRef.current = '';
    dummyCharInputRef.current = '';
    setDummyInput('');
    setDummyCharInput('');
    syncKeyboardValue(plateCharKeyboardRef, '');
    syncKeyboardValue(plateNumKeyboardRef, '');
  };

  const clearTicketInput = () => {
    setInputData('');
    ticketKeyboardRef.current && ticketKeyboardRef.current.setInput('');
  };

  // useEffect(() => {
  //   if (cashOpened === true) {
  //     searchTicket();
  //   } else if (vehicleData?.pass_id) {
  //     searchTicket();
  //   }
  // }, [cashOpened, searchTicket, vehicleData?.pass_id]);

  const now = dayjs();
  const date1 = dayjs(ticketData?.result?.start_time);
  const date2 = dayjs(
    !ticketData?.result?.end_time
      ? now
      : !ticketData?.result?.tickets?.exit_time
      ? ticketData?.result?.end_time
      : ticketData?.result?.tickets?.exit_time,
  );
  const TotalSeconds = date2.diff(date1, 'minutes');
  const hours = Math.ceil(TotalSeconds / 60);
  const startDate = dayjs(ticketData?.result?.start_time).format('DD-MM-YYYY HH:mm').slice(0, -5);
  const startTime = dayjs(ticketData?.result?.start_time).format('DD-MM-YYYY HH:mm').slice(10);

  const endDate = dayjs(
    ticketData?.result?.tickets?.ticket_status_types?.id === 3
      ? ticketData?.result?.tickets?.exit_time
      : !ticketData?.result?.end_time
      ? now
      : ticketData?.result?.end_time,
  )
    .format('DD-MM-YYYY HH:mm')
    .slice(0, -5);
  const endTime = dayjs(
    ticketData?.result?.tickets?.ticket_status_types?.id === 3
      ? ticketData?.result?.tickets?.exit_time
      : !ticketData?.result?.end_time
      ? now
      : ticketData?.result?.end_time,
  )
    .format('DD-MM-YYYY HH:mm')
    .slice(10);

  // eslint-disable-next-line no-nested-ternary
  const mobileNumberValue = isMobileEdit
    ? mobileData
    : !ticketData?.result?.customers?.mobile
    ? ticketData?.result?.guest_users?.mobile
    : ticketData?.result?.customers?.mobile;
  console.log('mobileNumberValue', mobileNumberValue);
  const cashCollect = () => {
    const body = {
      reservation_id: parseInt(ticketData?.result?.id, 10),
      mobile: mobileNumberValue,
    };
    sendRequest(`cashier/cash-payment`, 'post', body)
      .then(({ data, code }) => {
        if (code === 20) {
          setCashData(data);
          setCashOpened(false);
          setPayOpen(true);
          searchTicket();
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      });
  };

  // const cardCollect = () => {
  //   const body = {
  //     reservation_id: parseInt(ticketData?.result?.id, 10),
  //     transaction_id: parseInt(paymentStatus?.RetrievalReferenceNumber, 10),
  //   };
  //   // mutate(`generate-otp`, () => {
  //   sendRequest(`cashier/cash-payment`, 'post', body)
  //     .then(({ data, code }) => {
  //       if (code === 20) {
  //         setCashData(data);
  //         searchTicket();
  //         setCashOpened(false);
  //         searchTicket();
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       if (err?.response?.data?.code) {
  //         console.log('err', err?.response?.data?.code);
  //       }
  //     });
  //   // });
  // };

  useEffect(() => {
    if (
      paymentStatus?.TransactionResponseEnglish ||
      paymentStatus?.TransactionResultReasonEnglish === 'APPROVED'
    ) {
      const body = {
        reservation_id: parseInt(ticketData?.result?.id, 10),
        transaction_id: paymentStatus?.RetrievalReferenceNumber,
      };
      sendRequest(`cashier/card-payment`, 'post', body)
        .then(({ data, code }) => {
          if (code === 20) {
            setCashData(data);
            searchTicket();
            setPayOpen(true);
            searchTicket();
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            showNotification({
              title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        });
    }
  }, [
    paymentStatus,
    paymentStatus?.RetrievalReferenceNumber,
    response.EventName,
    paymentStatus?.TransactionResponseEnglish,
    ticketData?.result?.id,
  ]);

  const [barcodeRead, setBarcodeRead] = useState('');

  const barcode = {
    timing: 1000,
    data: '',
  };

  const barcodeReaded = () => {
    if (barcode.data.length > 1) {
      setBarcodeRead(barcode.data);
    } else {
      barcode.data = '';
    }
  };

  let timeout = setTimeout(barcodeReaded, 500);

  useEffect(() => {
    window.addEventListener('keypress', (e) => {
      if (barcode.data.length === 0 || e.timeStamp - barcode.timing < 1000) {
        barcode.data += e.key;
        barcode.timing = e.timeStamp;
        clearTimeout(timeout);
        timeout = setTimeout(barcodeReaded, 500);
      } else {
        barcode.data = '';
      }
    });
  }, []);

  useEffect(() => {
    const urlValue = barcodeRead;
    const arrayString = urlValue?.split('/home');
    const targetValue = arrayString[arrayString?.length - 1];
    const ticketValue = targetValue.slice(37);
    setTicketNumber(ticketValue);
    if (ticketNumber !== 0) {
      sendRequest(`cashier/reservations-by-pass-id/${ticketNumber}`, 'get')
        .then((res) => {
          if (res?.code === 20) {
            setTicketData(res?.data || []);
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            showNotification({
              title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        });
    }
  }, [barcodeRead, ticketNumber]);

  const mobileEdit = () => {
    setIsMobileEdit(!isMobileEdit);
  };
  const showError = touched && (mobileData.length < 7 || mobileData.length > 12);

  const status = `?is_online=${true}`;
  const shiftUpdate = () => {
    sendRequest(`/cashier/change-status${status}`, 'post')
      .then(({ msg }) => {
        if (msg === 'Profile online status updated successfully!') {
          // setOpened(false);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          // eslint-disable-next-line no-console
          console.log('err', err?.response?.data?.code);
        }
      });
  };

  useEffect(() => {
    shiftUpdate();
  }, []);

  useEffect(() => {
    if (activeTab === 'first') {
      setInputData('');
    } else if (activeTab === 'second') {
      setDummyInput('');
      setDummyCharInput('');
    }
  }, [activeTab]);

  return (
    <LandingLayout
      className="no-printme"
      paymentStatus={ticketData?.result?.invoices?.invoice_status?.name}
      ticketId={ticketData?.id}
      totalSeconds={TotalSeconds}
    >
      <div>
        <AppShell
          style={{
            position: 'fixed',
            width: '1000px',
            // marginBottom: '10px',
          }}
          styles={{
            main: {
              background:
                theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
            },
          }}
          navbarOffsetBreakpoint="sm"
          asideOffsetBreakpoint="sm"
          navbar={
            <Navbar
              p="md"
              hiddenBreakpoint="sm"
              width={{ sm: 330, lg: 350 }}
              sx={{ padding: '3px 0 0 15px !important' }}
              className="no-printme"
            >
              <Tabs value={activeTab} onTabChange={setActiveTab} color="dark" variant="pills">
                <Tabs.List>
                  <Tabs.Tab value="first">Plate Number</Tabs.Tab>
                  <Tabs.Tab value="second">Ticket Number</Tabs.Tab>
                </Tabs.List>

                <Tabs.Panel value="first">
                  <Center py="xs">
                    <Text>ENTER PLATE NUMBER</Text>
                  </Center>
                  <Group style={{ margin: '0 0 0 1px' }} dir="ltr">
                    <Center>
                      <OTPInput
                        OTPLength={4}
                        // placeholder="1234"
                        inputStyles={{
                          width: '30px',
                          height: '30px',
                          fontSize: '1.3rem',
                          margin: '5px',
                        }}
                        otpType="number"
                        value={dummyInput}
                        onChange={onChangePlateDigits}
                        disabled={ticketData?.id}
                        onKeyDown={handlePlateDigitKeyDown}
                      />
                    </Center>
                    <Center>
                      <OTPInput
                        OTPLength={3}
                        inputStyles={{
                          width: '30px',
                          height: '30px',
                          fontSize: '1.3rem',
                          margin: '5px',
                        }}
                        otpType="alpha"
                        value={dummycharInput}
                        onChange={onChangePlateChars}
                        disabled={ticketData?.id}
                        onKeyDown={handlePlateCharKeyDown}
                      />
                    </Center>
                  </Group>

                  <Stack position="apart" py="xs">
                    <Box style={{ width: '300px' }} dir="ltr">
                      <Keyboard
                        // eslint-disable-next-line no-return-assign
                        keyboardRef={(r) => (plateCharKeyboardRef.current = r)}
                        onKeyPress={onPlateCharKeyPress}
                        layoutName={layout}
                        maxLength={3}
                        preventMouseDownDefault
                        disableCaretPositioning
                        layout={{
                          default: ['A B J D', 'R S X T', 'E G K L', 'Z N H U', '{shift} V {bksp}'],
                          shift: ['ن ه و ي', 'ق ك ل م', 'س ص ط ع', 'ب ح د ر', '{shift} أ {bksp}'],
                        }}
                        display={{
                          '{bksp}': '⌫',
                          '{enter}': shiftButtonText !== 'Arabic' ? 'إرسال' : 'Enter',
                          '{shift}': shiftButtonText !== 'Arabic' ? 'ENG' : 'عربي',
                        }}
                      />
                      <Keyboard
                        // eslint-disable-next-line no-return-assign
                        keyboardRef={(r) => (plateNumKeyboardRef.current = r)}
                        onKeyPress={onPlateDigitKeyPress}
                        layoutName={layout}
                        maxLength={4}
                        preventMouseDownDefault
                        disableCaretPositioning
                        layout={{
                          default: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
                          shift: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
                        }}
                        display={{
                          '{bksp}': '⌫',
                          '{enter}': 'Enter',
                        }}
                      />

                      <Center py="xs">
                        <Button variant="subtle" onClick={clearPlateInputs}>
                          Clear
                        </Button>
                      </Center>

                      <Keyboard
                        // eslint-disable-next-line no-return-assign
                        keyboardRef={(r) => (keyboard.current = r)}
                        onChange={onChange}
                        onKeyPress={onKeyPress}
                        layoutName={layout}
                        maxLength={2}
                        layout={{
                          default: ['{enter}'],
                          shift: ['{enter}'],
                        }}
                        display={{
                          // '{enter}': 'Enter',
                          '{enter}': shiftButtonText !== 'Arabic' ? 'إرسال' : 'Enter',
                        }}
                      />
                    </Box>

                    {isMobileEdit ? (
                      <Keyboard
                        keyboardRef={(r) => (keyboard.current = r)}
                        onChange={onChangeMobileNumber}
                        layoutName={layout}
                        onKeyPress={onKeyPress}
                        maxLength={12}
                        layout={{
                          default: ['1 2 3 4 5 6', '7 8 9 0 {bksp}'],
                          shift: ['1 2 3 4 5 6', '7 8 9 0 {bksp}'],
                        }}
                        display={{
                          '{bksp}': '⌫',
                          '{enter}': 'Enter',
                        }}
                      />
                    ) : null}
                  </Stack>
                </Tabs.Panel>
                <Tabs.Panel value="second">
                  <div style={{ margin: '10px 0 8px 0px' }}>
                    <Center py="xs">
                      <Text>ENTER TICKET NUMBER</Text>
                    </Center>

                    <Input
                      // placeholder={t('enter.ticket.number.placeholder')}
                      value={inputData}
                      width="30px"
                      onChange={onChangeInputNumber}
                      ref={focusTrapRef}
                      py="xl"
                    />
                  </div>
                  <div dir="ltr">
                    <Keyboard
                      keyboardRef={(r) => (ticketKeyboardRef.current = r)}
                      onChange={onChangeNumber}
                      layoutName={layout}
                      onKeyPress={onKeyPress}
                      maxLength={20}
                      layout={{
                        default: ['1 2 3', '4 5 6', '7 8 9', '{enter} 0 {bksp}'],
                        shift: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
                      }}
                      display={{
                        '{bksp}': '⌫',
                        '{enter}': 'Enter',
                      }}
                    />
                  </div>
                  <Space h="xl" />
                  <Center>
                    <Button variant="subtle" onClick={clearTicketInput}>
                      Clear
                    </Button>
                  </Center>
                  {isMobileEdit ? (
                    <Keyboard
                      keyboardRef={(r) => (mobileKeyboardRef.current = r)}
                      onChange={onChangeMobileNumber}
                      layoutName={layout}
                      onKeyPress={onKeyPress}
                      maxLength={12}
                      layout={{
                        default: ['1 2 3 4 5 6', '7 8 9 0 {bksp}'],
                        shift: ['1 2 3 4 5 6', '7 8 9 0 {bksp}'],
                      }}
                      display={{
                        '{bksp}': '⌫',
                        '{enter}': 'Enter',
                      }}
                    />
                  ) : null}
                </Tabs.Panel>
              </Tabs>
            </Navbar>
          }
          aside={
            <MediaQuery smallerThan="sm" styles={{ display: 'none' }} className="no-printme">
              <Aside p="md" hiddenBreakpoint="sm" width={{ sm: 220, lg: 360 }}>
                <Profile />
              </Aside>
            </MediaQuery>
          }
        >
          <Box style={{ width: '470px', margin: '-25px 0 0 -38px' }} className="no-printme">
            {ticketData?.result?.id ? (
              <Paper shadow="lg" withBorder p="xl">
                <Stack>
                  <Group position="apart" style={{ marginBottom: '-20px' }}>
                    <Group>
                      <Stack>
                        <Center>
                          <Title size="sm" order={2}>
                            Entry
                          </Title>
                        </Center>
                        <Center style={{ marginBottom: '-18px' }}>
                          <Text size="sm" weight={500}>
                            {startDate}
                          </Text>
                        </Center>
                        <Center>
                          <Text size="sm" weight={500}>
                            {startTime}
                          </Text>
                        </Center>
                      </Stack>
                    </Group>
                    <ActionIcon
                      color="dark"
                      size="xl"
                      radius="xl"
                      variant="default"
                      sx={{
                        borderColor: 'black',
                        width: '80px',
                        height: '80px',
                        borderRadius: '50px',
                      }}
                    >
                      <Text weight={900} size="lg">
                        {hours === 0 ? 1 : hours} hrs
                      </Text>
                    </ActionIcon>
                    <Group>
                      <Stack>
                        <Center>
                          <Title size="sm" order={2}>
                            Exit
                          </Title>
                        </Center>
                        <Center style={{ marginBottom: '-18px' }}>
                          <Text size="sm" weight={500}>
                            {endDate}
                          </Text>
                        </Center>
                        <Center>
                          <Text size="sm" weight={500}>
                            {endTime}
                          </Text>
                        </Center>
                      </Stack>
                    </Group>
                  </Group>
                  <Space h="xs" />
                  <Group>
                    <Stack>
                      <Title size="sx" order={2}>
                        Description
                      </Title>

                      {ticketData?.result?.vas_orders.map((item) => (
                        <Text size="sm" weight={500} color="#817E7E">
                          {item?.vas_types?.name}
                        </Text>
                      ))}

                      {ticketData?.result?.enforcements.map((em) => (
                        <Text size="sm" weight={500} color="#817E7E">
                          {em?.name}
                        </Text>
                      ))}

                      <Text size="sm" weight={500} color="#817E7E">
                        {hours === 0 ? 1 : hours} hours parking
                      </Text>

                      <Text size="sm" weight={500} color="#817E7E">
                        Tax ( 15% )
                      </Text>
                    </Stack>
                    <Stack>
                      <Title size="sm" order={2}>
                        Unit Amount
                      </Title>

                      {ticketData?.result?.vas_orders.map((item) => (
                        <Text size="sm" weight={500} color="#817E7E">
                          {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                            ? 0
                            : Number(item?.amount).toFixed(2)}{' '}
                        </Text>
                      ))}

                      {ticketData?.result?.enforcements.map((em) => (
                        <Text size="sm" weight={500} color="#817E7E">
                          {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                            ? 0
                            : Number(em?.amount).toFixed(2)}{' '}
                        </Text>
                      ))}

                      <Text size="sm" weight={500} color="#817E7E">
                        {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                          ? 0
                          : Number(ticketData?.result?.amount).toFixed(2)}{' '}
                      </Text>

                      <Text size="sm" weight={500} color="#817E7E">
                        {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                          ? 0
                          : Number(ticketData?.result?.invoices?.tax).toFixed(2)}{' '}
                      </Text>
                    </Stack>

                    <Stack>
                      <Title size="sm" order={2}>
                        Quantity
                      </Title>

                      {ticketData?.result?.vas_orders.map((item) => (
                        <Text size="sm" weight={500} color="#817E7E">
                          {item?.qty}
                        </Text>
                      ))}

                      {ticketData?.result?.enforcements.map((em) => (
                        <Text size="sm" weight={500} color="#817E7E">
                          {em ? 1 : 0}
                        </Text>
                      ))}
                      <Text size="sm" weight={500} color="#817E7E">
                        {hours === 0 ? 1 : hours}
                      </Text>

                      <Text size="sm" weight={500} color="#817E7E">
                        1
                      </Text>
                    </Stack>

                    <Stack>
                      <Title size="sm" order={2}>
                        Amount
                      </Title>

                      {ticketData?.result?.vas_orders.map((item) => (
                        <Text size="sm" weight={500} color="#817E7E">
                          {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                            ? 0
                            : Number(item?.amount).toFixed(2)}{' '}
                          SAR
                        </Text>
                      ))}

                      {ticketData?.result?.enforcements.map((em) => (
                        <Text size="sm" weight={500} color="#817E7E">
                          {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                            ? 0
                            : Number(em?.amount).toFixed(2)}{' '}
                          SAR
                        </Text>
                      ))}

                      <Text size="sm" weight={500} color="#817E7E">
                        {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                          ? 0
                          : // eslint-disable-next-line no-unsafe-optional-chaining
                            Number(ticketData?.result?.amount * hours).toFixed(2)}{' '}
                        SAR
                      </Text>

                      <Text size="sm" weight={500} color="#817E7E">
                        {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                          ? 0
                          : Number(ticketData?.result?.invoices?.tax).toFixed(2)}{' '}
                        SAR
                      </Text>
                    </Stack>
                  </Group>
                </Stack>
                <Space h="xs" />

                <Divider size="sm" />
                <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                  <Title size="sm" order={1}>
                    Total
                  </Title>
                  <Title size="sm" order={1}>
                    {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                      ? 0
                      : ticketData?.result?.invoices?.payable_amount.toFixed(2)}
                  </Title>
                  <Title size="sm" order={1}>
                    SAR
                  </Title>
                </Group>
                <Divider size="sm" />

                <Stack>
                  <Title order={5}>Customer Info</Title>
                  <Group>
                    {ticketData?.result?.guest_users === null ? (
                      <Title order={5}>
                        Name:{' '}
                        {!ticketData?.result?.customers?.full_name
                          ? 'Guest'
                          : ticketData?.result?.customers?.full_name}
                      </Title>
                    ) : (
                      <Title order={5}>
                        Name:{' '}
                        {!ticketData?.result?.guest_users?.first_name
                          ? 'Guest'
                          : ticketData?.result?.guest_users?.first_name}
                      </Title>
                    )}
                    <Group>
                      <Input.Label required>Mobile:</Input.Label>
                      {!isMobileEdit ? (
                        <>
                          {ticketData?.result?.guest_users === null ? (
                            <Group>
                              <Title order={5}>
                                {!ticketData?.result?.customers?.country_code?.dial_code
                                  ? '---'
                                  : ticketData?.result?.customers?.country_code?.dial_code}
                              </Title>
                              <Title order={5}>
                                {!ticketData?.result?.customers?.mobile
                                  ? '---'
                                  : ticketData?.result?.customers?.mobile}
                              </Title>
                            </Group>
                          ) : (
                            <Group>
                              <Title order={5}>
                                {!ticketData?.result?.guest_users?.country_code?.dial_code
                                  ? '---'
                                  : ticketData?.result?.guest_users?.country_code?.dial_code}
                              </Title>
                              <Title order={5}>
                                {!ticketData?.result?.guest_users?.mobile
                                  ? '---'
                                  : ticketData?.result?.guest_users?.mobile}
                              </Title>
                            </Group>
                          )}
                        </>
                      ) : (
                        <Input.Wrapper required>
                          <Input
                            style={{ width: '150px' }}
                            // type="number" hideControls maxLength={12}
                            minLength={7}
                            value={mobileData}
                            onChange={onChangeInputMobileNumber}
                            ref={focusTrapRef}
                          />
                          {showError && (
                            <Text fz="xs" color="red">
                              Mobile Number min 7 and max 12
                            </Text>
                          )}
                        </Input.Wrapper>
                      )}

                      <ActionIcon>
                        {!isMobileEdit ? (
                          <Edit size={48} strokeWidth={2} color="black" onClick={mobileEdit} />
                        ) : (
                          <EditOff size={48} onClick={mobileEdit} strokeWidth={2} color="black" />
                        )}
                      </ActionIcon>
                    </Group>
                  </Group>
                  <Group>
                    <Title order={5}>payment Info : </Title>
                    {ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
                      <Title order={5}> Paid </Title>
                    ) : (
                      <Title order={5}> Pending </Title>
                    )}
                  </Group>

                  {ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
                    <Center>
                      <Button
                        style={{ width: '45%', backgroundColor: '#01AA84' }}
                        onClick={() => setOpenInvoice(true)}
                      >
                        Print Invoice
                      </Button>
                    </Center>
                  ) : (
                    <Group px="xl">
                      <Button
                        leftIcon={<Image src={cardIcon} size={14} />}
                        style={{ width: '45%', backgroundColor: '#01AA84' }}
                        onClick={cardPayment}
                        disabled={
                          ticketData?.result?.invoices?.invoice_status?.name === 'paid' ||
                          TotalSeconds <= 5
                        }
                      >
                        Card
                      </Button>
                      <Button
                        leftIcon={<Image src={cashIcon} size={14} />}
                        style={{ width: '45%', backgroundColor: '#01AA84' }}
                        onClick={() => setCashOpened(true)}
                        disabled={TotalSeconds <= 5}
                      >
                        {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                          ? 'Print Invoice'
                          : 'Cash'}
                      </Button>
                    </Group>
                  )}
                </Stack>
              </Paper>
            ) : (
              <Box>
                <Stack>
                  <Center>
                    <Title>Waiting for Details...</Title>
                  </Center>
                  <Center>
                    <Title>search by</Title>
                  </Center>
                  <Center>
                    <Title>NumberPlate</Title>
                  </Center>
                  <Center>
                    <Title>/</Title>
                  </Center>
                  <Center>
                    <Title>Ticket Number</Title>
                  </Center>
                </Stack>
              </Box>
            )}
          </Box>

          {/* Sdasdasdasdas */}

          <Modal
            opened={opened}
            centered
            onClose={() => setOpened(false)}
            title={
              <Text p="xl" className="no-printme">
                {profileData?.is_online === true
                  ? 'You want to end the shift'
                  : 'You want to start the shift'}
              </Text>
            }
          >
            <Center>
              <Group>
                {/* <Button
                  style={{ backgroundColor: '#01AA84' }}
                  // onClick={() => {
                  //   localStorage.setItem('token', '');
                  //   '/login';
                  // }}
                  onClick={() => setOpened(false)}
                >
                  Confirm to Shift End
                </Button> */}
                <CashierAmount profile={profileData} amountTotal={totalAmountData} />
              </Group>
            </Center>
          </Modal>

          <Modal
            opened={cardPay}
            onClose={() => setCardPay(false)}
            centered
            // title={<Text p="xl">You want to end the shift</Text>}
          >
            <Center>
              {response?.TerminalAction === 'SWIPE_OR_INSERT' ? (
                <Stack>
                  <Title order={1}>Swipe or Insert</Title>
                  <Center>
                    <Title order={1}>Card</Title>
                  </Center>
                </Stack>
              ) : (
                <div>
                  {response?.TerminalAction === 'USER_CANCELLED_AND_TIMEOUT' ? (
                    <Stack>
                      <Title order={1}>Cancel or Timeout</Title>
                    </Stack>
                  ) : (
                    <div>
                      {paymentStatus?.TransactionResponseEnglish ||
                      paymentStatus?.TransactionResultReasonEnglish === 'APPROVED' ||
                      ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
                        <PaymentStatus
                          invoiceDataId={ticketData?.result?.invoices?.invoice_number}
                          passDataId={inputData}
                          profile={profileData}
                        />
                      ) : paymentStatus?.TransactionResponseEnglish ||
                        paymentStatus?.TransactionResultReasonEnglish === 'DECLINED' ? (
                        <Stack>
                          <Title order={1}>Card Declined</Title>
                        </Stack>
                      ) : response?.TerminalAction === 'SENDING_REQUEST' ? (
                        <Stack>
                          <Title order={1}>Processing...</Title>
                        </Stack>
                      ) : null}
                    </div>
                  )}
                </div>
              )}
            </Center>
          </Modal>

          <Modal
            opened={cashOpened}
            onClose={() => setCashOpened(false)}
            centered
            // title={<Text p="xl">Collected Amount</Text>}
          >
            <Center>
              {ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? null : (
                <Title order={1}>
                  Amount : {ticketData?.result?.invoices?.payable_amount.toFixed(2)} SAR
                </Title>
              )}
            </Center>
            <Center py="xl">
              {ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
                <PaymentStatus
                  invoiceDataId={ticketData?.result?.invoices?.invoice_number}
                  passDataId={inputData}
                  profile={profileData}
                />
              ) : (
                <Button style={{ width: '40%', backgroundColor: '#01AA84' }} onClick={cashCollect}>
                  <Text>Collect</Text>
                </Button>
              )}
            </Center>
          </Modal>
          <Modal
            opened={payOpen}
            // onClose={() => setPayOpen(false)}
            centered
            withCloseButton={false}
            // title={<Text p="xl">Collected Amount</Text>}
          >
            <Center py="xl">
              <PaymentStatus
                invoiceDataId={ticketData?.result?.invoices?.invoice_number}
                passDataId={ticketIdData}
                profile={profileData}
              />
            </Center>
          </Modal>
          <Modal
            opened={openInvoice}
            // onClose={() => setOpenInvoice(false)}
            withCloseButton={false}
            centered
            // title={<Text p="xl">Collected Amount</Text>}
          >
            <PrintInvoice
              invoiceDataId={ticketData?.result?.invoices?.invoice_number}
              passDataId={ticketIdData}
              profile={profileData}
            />
          </Modal>
        </AppShell>
      </div>
    </LandingLayout>
  );
};

export default Home;
